import { Button, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Text } from "react-internationalization";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
//import ProspectBulkUpload from "./ProspectBulkUpload"
import SelectedFileTable from "./SelectedFileTable";
import CampaignGuidelines from "../Guidelines/CampaignGuidelines"
import Alert from "@material-ui/lab/Alert";
import * as DateUtil from "../../../Utils/DatePicker";
import { Styles } from "../../../assests/styles/DashboradStyles";
//import BulkTable from "./BulkTable";
import DataTable from "../../../Utils/GenericUI/DataTable";
import AutoComplete1 from "../../../Utils/Select";
// import ExcelReader from "../../Utils/Excel/ExcelReader";
import CsvReader from "../../../Utils/Excel/CsvReader";
import {
  ProspectManagementSaveProspect,
  getCampaignList,
  campaignFileTable,
  campaignFileData,
} from "../../../Redux/Actions/webAppActions";

import {
  handleDateChange,
  formatPhoneNumber,
} from "../../../Utils/DateFormatter";
import {
  BulkHeader,
  CampaignModalBulkHeader,
} from "../../../Utils/StaticData/DashboardHeader";
import SimpleReactValidator from "simple-react-validator";
import { useSelector, useDispatch } from "react-redux";
import { connect } from "react-redux";

const CustomSearchButton = withStyles({
  root: {
    backgroundColor: "#0089cf",
    borderColor: "#0089cf",
    "&:hover": {
      backgroundColor: "#0e4686",
      borderColor: "#0e4686",
      boxShadow: "none",
    },
  },
})(Button);

const validator = new SimpleReactValidator({
  messages: {
    required: ":attribute is required",
  },
  validators: {
    phone_no: {
      message: "Please enter valid 10 digit number.",
      rule: (val, params) => {
        if (val.length !== 12) {
          return false;
        }
        return true;
      },
    },
    plan_testing: {
      message: "Please select valid Plan",
      rule: (val, params) => {
        let test = val[1].find((o) => o.label === val[0]);
        if (!isEmpty(test)) {
          return true;
        }
        return false;
      },
    },
    grp_chk: {
      message: "Please select valid Role",
      rule: (val, params) => {
        let test = val[1].find((o) => o.value === val[0]);
        if (!isEmpty(test)) {
          return true;
        }
        return false;
      },
    },
    chk_char: {
      message: "Only alphabets are required",
      rule: (val, params) => {
        let flag;
        if (val.match("^[A-Za-z]+$")) {
          flag = true;
        } else {
          flag = false;
        }
        return flag;
      },
    },
  },
});
const associatedProduct = [
  { label: "WIPRO PREMIER ADVANTAGE ELITE", value: "0" },
  { label: "WIPRO PREMIER ADVANTAGE ELITE", value: "1" },
  { label: "WIPRO ESSENCE ADVANTAGE (HMO)", value: "2" },
  { label: "WIPRO ESSENCE ADVANTAGE PLUS (HMO)", value: "3" },
  { label: "WIPRO PREMIER ADVANTAGE ELITE", value: "4" },
];
const campaignMedia = [
  { label: "TV", value: "0" },
  { label: "News Paper", value: "1" },
  { label: "Direct mail", value: "2" },
  { label: "Non-Campaign", value: "3" },
  { label: "workshop", value: "4" },
  { label: "Social Media", value: "5" },
];
const status = [
  { label: "Open", value: "Open" },
  { label: "Hold", value: "Hold" },
  { label: "Closed", value: "Closed" },
];
const CampaignBulkUpload = (props) => {
  
  //const [CampaignBulkModaldata, setCampaignBulkModaldata] = React.useState([]);

  const [CampaignBulkData, setCampaignBulkData] = useState([]);
  const [rowCount] = React.useState(0);

  const [selectedFile, setSelectedFile] = useState("All");
  const [selectedFilestatus, setSelectedFilestatus] = useState("All");
  const [SelectedFileId, setSelectedFileId] = useState("All");
  // const [csvData] = React.useState([]);
  const [rowsPerPage, setrowsPerPage] = React.useState(5);
  const [selectedRowIndex, setselectedRowIndex] = React.useState(0);
  // const [csvheaderCampaign] = React.useState([
  //   { label: "Plan_Campaign_Id", key: "Plan_Campaign_Id" },
  //   { label: "Plan_Campaign_Name", key: "Plan_Campaign_Name" },
  //   { label: "Associated_Product", key: "Associated_Product" },
  //  // { label: "Campaign_Owner", key: "Campaign_Owner" },
  //   { label: "Campaign_Status", key: "Campaign_Status" },
  //   { label: "Campaign_Media", key: "Campaign_Media" },
  //   { label: "Campaign_Start_Date", key: "Campaign_Start_Date" },
  //   { label: "Campaign_End_Date", key: "Campaign_End_Date" },
  //   { label: "Campaign_Owner_Id", key: "Campaign_Owner_Id" },
  // ]);

  const campaignUplodedFiles = useSelector((state) => state.bulk.campaignUplodedFiles);
  const dispatch = useDispatch();
  

  const columnSelected = async (fileName, fileId, status1) => {
    //call api to load the data for a particular file in the pop up
    await dispatch(
      campaignFileData({
        fileId: fileId,
        status: status1,
      })
    );
    setSelectedFile(fileName);
    setSelectedFilestatus(status1);

    setSelectedFileId(fileId);
   // setCampaignBulkModaldata(res?.data);
  };
  const rowSelect = async (index, selectedData, rowsPerPage1, type) => {
    setrowsPerPage(rowsPerPage1);
    setselectedRowIndex(index);
  };

  const handleChangeRowsPerPage = async (rowsPerPage2) => {
    setrowsPerPage(rowsPerPage2);
  };

  
 
 
 

  

  // in useeffect call the api to load main bulk and store in bulk data
  useEffect(() => {
   
    const user = async () => {
      
      const res = await dispatch(campaignFileTable());
      //console.log("clsbulk1",res.data)
      if (res?.status === "OK") {
        await setCampaignBulkData(res?.data);
      }
    };
    user();
  }, []);
  useEffect(() => {
    setCampaignBulkData(campaignUplodedFiles);
  }, [campaignUplodedFiles]);
  const goBack = async () => {
    setSelectedFile("All");
  };
  return (
    <React.Fragment>
      <div 
      //style={{ marginTop: "1rem", marginLeft: "1rem" }}
      >
        {selectedFile === "All" ? (
           <div class="container-campaignmain prospecttablealign mt-3 mb-3">
            <div className="Fieldcontainer text-justify">
              <div>
              <Text>
                Please follow the desired format while uploading a bulk list of
                prospects.
              </Text>
              <p>
                <Text>For quick reference,{" "}</Text>
                <a href={require("./samplecampaign.csv")} download={"samplecampaign.csv"}>click here{" "}</a>
                <Text>to view a template.</Text>
              </p>
              </div>
              <div class="mt-2">
                  <CampaignGuidelines customerId={props?.customerId}/>
                  </div>
              <CsvReader
                bulkUploadProspect={false}
                bulkUploadCampaign={true}
              />
            </div>
            <div style={{ overflow: "auto" }}>
              <DataTable
                //modalSelect={"#BulkModalCampaign"}
                width="100%"
                padding="4px 45px 4px 8px"
                dashboard="BulkUploadMain"
                headerPadding="8px 12px 9px 47px"
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 15]}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                clicked={rowSelect}
                columnSelected={columnSelected}
                setClick={(x) => {}}
                index={selectedRowIndex}
                sortable={true}
                searchable={true}
                header={BulkHeader}
                rowcount={rowCount}
                data={CampaignBulkData}
                exportAsExcel={true}
                // clickedFirst={this.prospectrowSelectFirst}
              />
            </div>
          </div>
        ) : (
          <SelectedFileTable
            dashboard="ProspectBulkUploadModal"
            rowcount={rowCount}
            selectedFile={selectedFile}
            selectedFilestatus={selectedFilestatus}
            SelectedFileId={SelectedFileId}
            goBack={goBack}
          />
        )}
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    prospectagentList: state.campaignProspect.agentList,
    campaignNames: state.campaignProspect.campaignNamesList,
  };
};
const mapDispatchToProps = {
  ProspectManagementSaveProspect,
  getCampaignList,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(CampaignBulkUpload));
